import { useSelector } from "@nf/common";

export const useDataPayment = () => {
  const {
    paymentOrder: {
      Data: paymentOrder,
      Initialized: orderInitialized,
      IsProcessing: isOrderLoading,
      Completed: orderCompleted,
      Error: orderError,
    },
    payment: {
      Data: payment,
      IsProcessing: isPaymentLoading,
      Completed: paymentCompleted,
      Error: paymentError,
    },
    paymentsInfo: {
      IsProcessing: isPaymentInfoLoading,
      Error: paymentInfoError,
      Initialized: paymentInfoInitialized,
      Completed: paymentInfoCompleted,
    },
    selectedOffer: { offerId, voucherCoupon },
  } = useSelector((state) => state.payment);

  const { action, isLoading: isAuthenticationLoading } = useSelector(
    (state) => state.auth
  );

  const methods = useSelector(
    (state) => state.payment.paymentsInfo.Data?.methods
  );

  const selectedOffer = useSelector((state) =>
    state.payment.paymentsInfo.Data?.offers.find(
      (offer) => offer.Id === offerId
    )
  );

  const offersList = useSelector(
    (state) => state.payment.paymentsInfo.Data?.offers
  );

  return {
    paymentOrder,
    orderInitialized,
    orderCompleted,
    isOrderLoading,
    orderError,
    payment,
    isPaymentLoading,
    paymentError,
    paymentCompleted,
    isPaymentInfoLoading,
    paymentInfoError,
    isAuthenticationLoading,
    methods,
    action,
    offersList,
    selectedOffer,
    voucherCoupon,
    offerId,
    paymentInfoInitialized,
    paymentInfoCompleted,
  };
};
